/**
 * Adapptio Core library.
 *
 * @package lib-core
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export const RENDERER = {
	DEFAULT_SSR_ENABLED: true,
	DEFAULT_SSR_TIMEOUT: 2000,
	/** View To Html node rendering timeout */
	VIEW_TO_RENDERER_SSR_TIMEOUT: 10000
};
